import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getDealsList, selectDealsList, resetStore } from "../../redux/modules/deals";
import Layout from "../layout";
import Loader from "../common/loader";
import Table from "../common/table";
import FilterDeals from "./filter-deals";

const Deals = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(true);
  const [active, setActive] = useState(location.state ? decodeURI(location.state.hash) : (window.location.hash ? decodeURI(window.location.hash.split('#')[1]) : "На подготовке"));

  const [fields, setValue] = useState({
    manager: { value: "" },
    broker: { value: "" },
    projectId: { value: "" },
    typeId: { value: "" },
    search: { value: "" },
    amount: { value: "" },
    commission: { value: "" },
  });
  const [items, setItems] = useState(null);

  const auth = useSelector((state) => state.auth);
  const deals = useSelector((state) => state.deals);
  const dealslist = useSelector((state) => selectDealsList(state));
  const mobile = useSelector((state) => state.mobile);

  const columns =
    auth.user.group === "lead"
      ? [
          { label: "Клиент", value: "clientName" },
          { label: "Телефон", value: "clientPhone" },
          { label: "Менеджер", value: "manager" },
          { label: "Брокер", value: "brocker" },
          { label: "Проект/Тип объекта", value: "project" },
          { label: "Сумма сделки", value: "amount" },
          { label: "Комиссия", value: "commission" },
          { label: "Статус", value: "status" },
        ]
      : [
          { label: "Клиент", value: "clientName" },
          { label: "Телефон", value: "clientPhone" },
          { label: "Менеджер", value: "manager" },
          { label: "Проект/Тип объекта", value: "project" },
          { label: "Сумма сделки", value: "amount" },
          { label: "Комиссия", value: "commission" },
          { label: "Статус", value: "status" },
        ];

  const columnsmobile =
    auth.user.group === "lead"
      ? [
          { label: "Клиент", value: "clientName" },
          { label: "Телефон", value: "clientPhone" },
          { label: "Проект/Тип объекта", value: "project" },
          { label: "Статус", value: "status" },
          { label: "Сумма сделки", value: "amount" },
          { label: "Комиссия", value: "commission" },
          { label: "Менеджер", value: "manager" },
          { label: "Брокер", value: "brocker" },
        ]
      : [
          { label: "Клиент", value: "clientName" },
          { label: "Телефон", value: "clientPhone" },
          { label: "Проект/Тип объекта", value: "project" },
          { label: "Статус", value: "status" },
          { label: "Сумма сделки", value: "amount" },
          { label: "Комиссия", value: "commission" },
          { label: "Менеджер", value: "manager" },
        ];

  const sortmobile = [
    { label: "Клиент", value: "clientName" },
    { label: "Телефон", value: "clientPhone" },
  ];
  
  const scrolled = () => {
    const width = window.innerWidth
    const scrollTop = width < 1000 ? document.querySelector('.page__content').scrollTop : document.querySelector('.tabs-content').scrollTop;
    const height =  width < 1000 ?  (document.querySelector('.visible').offsetTop + document.querySelector('.visible').offsetHeight - 48) : document.querySelector('.visible').offsetHeight;

    if (scrollTop > height ) {
      if(width < 1000) {
        document.querySelector('.table__head').classList.add('fixed');
        document.querySelector('.filter-btn').classList.add('visible');
      } else {
        setVisible(false);
      }
    } else {
      if(width < 1000) {
        document.querySelector('.table__head').classList.remove('fixed');
        document.querySelector('.filter-btn').classList.remove('visible');
      } else {
        setVisible(true);
      }    
    }
  };

  useEffect(() => {
    document.title = "Сделки | Личный кабинет Брокера THE FIVE";

    dispatch(
      getDealsList({
        cmd: "deal-list",
        _debug_token: auth.token,
      })
    );
    
    document.querySelector('.page__content').addEventListener('scroll', scrolled);
    document.querySelector('.tabs-content').addEventListener('scroll', scrolled);    
    
    return () => {      
      if(document.querySelector('.page__content') && document.querySelector('.page__content').length) document.querySelector('.page__content').addEventListener('scroll', scrolled);
      if(document.querySelector('.tabs-content') && document.querySelector('.tabs-content').length) document.querySelector('.tabs-content').removeEventListener('scroll', scrolled);
      dispatch(resetStore())
    }

  }, []);
  
  const handleFilterClick = () => {
    setVisible(!visible);
    document.querySelector('.tabs-content').scrollTo(0, 0) 
  };

  const handleClick = (status) => {
    setActive(status);
    navigate('#' + status);
  };

  const countItemsByStatus = (data, status) => {
    if (!data) return 0;
    return data.filter((item) => item.status === status).length;
  };

  const counts = {
    all: dealslist ? dealslist.length : 0,
    preparing: countItemsByStatus(dealslist, "На подготовке"),
    registration: countItemsByStatus(dealslist, "На регистрации"),
    active: countItemsByStatus(dealslist, "Действующий"),
  };
      
  const filteredData = items ? items.filter((item) => active === "Все" || item.status === active) : dealslist && !fields.amount.value && !fields.commission.value ? dealslist.filter((item) => active === "Все" || item.status === active) : [];

  return (
    <Layout>
      {deals.loading && <Loader />}
      <div className="deals-page">
        <div className="tabs">
          <div className="tabs__wrap">
            <div className="tabs__item" onClick={() => handleClick("Все")} data-active={active === "Все"} id={"Все"}>
              Все {counts.all > 0 && <span>{counts.all}</span>}
            </div>
            <div className="tabs__item" onClick={() => handleClick("На подготовке")} data-active={active === "На подготовке"} id={"На подготовке"}>
              {mobile ? 'Подготовка' : 'На подготовке'} 
              {counts.preparing > 0 && <span>{counts.preparing}</span>}
            </div>
            <div className="tabs__item" onClick={() => handleClick("На регистрации")} data-active={active === "На регистрации"} id={"На регистрации"}>
              {mobile ? 'Регистрация' : 'На регистрации'}
              {counts.registration > 0 && <span>{counts.registration}</span>}
            </div>
            <div className="tabs__item" onClick={() => handleClick("Действующий")} data-active={active === "Действующий"} id={"Действующий"}>
              Действующие 
              {counts.active > 0 && <span>{counts.active}</span>}
            </div>
          </div>
          {!visible && <div className="filter-btn" onClick={handleFilterClick}></div>}
        </div>

        <div className="tabs-content">
          <div className={visible ? "visible" : "visible visible_hide"}>
            <FilterDeals fields={fields} setValue={setValue} alldata={dealslist} setItems={setItems} data={filteredData} />
          </div>
          {mobile && <div className="filter-btn" onClick={() => document.querySelector('.page__content').scrollTo(0, 0) }></div>}  
          <Table bookingPage={true} columns={mobile ? columnsmobile : columns} sortmobile={sortmobile} data={filteredData} />
        </div>
      </div>
    </Layout>
  );
};

export default Deals;
